import AboutView from './components/AboutView'

export default {
  path: "about",
  component : AboutView
}



// WEBPACK FOOTER //
// ./src/routes/About/index.js